export const connectorViewMode = Object.freeze({
	Grid: 0,
	Image: 1,
});
